"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
require("moment/locale/es-us");
var _moment = _interopRequireDefault(require("moment"));
var _lodash = _interopRequireDefault(require("lodash"));
var _material = require("@mui/material");
var _constants = _interopRequireDefault(require("./constants"));
var _rangePicker = _interopRequireDefault(require("./rangePicker"));
var _menu = _interopRequireDefault(require("./menu"));
var _styles = _interopRequireDefault(require("./styles.scss"));
var _dateUtil = _interopRequireDefault(require("./dateUtil"));
var _buttonV = _interopRequireDefault(require("../buttonV2"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CLASS_NAME = _styles.default['date-range-picker'];
var DateRangePicker = /*#__PURE__*/function (_Component, _onSelectRange) {
  (0, _inherits2.default)(DateRangePicker, _Component);
  var _super = _createSuper(DateRangePicker);
  function DateRangePicker(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DateRangePicker);
    _this = _super.call(this, props);
    _this.state = {
      isOpenDropDown: false,
      anchor: null
    };
    _this.openDropdown = _this.openDropdown.bind((0, _assertThisInitialized2.default)(_this));
    _this.isOutsideRange = _this.isOutsideRange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSelectRange = _this.onSelectRange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDateRangesChange = _this.onDateRangesChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onApply = _this.onApply.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCancel = _this.onCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.dateElementRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  (0, _createClass2.default)(DateRangePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onMount();
    }

    /**
     * Initialize the state when this component is created.
     * @returns (Object)
     * rangePickerStartDate: Set to {startDate} if the selected filter ranges is {CUSTOM_RANGE}
     * rangePickerEndDate: Set to {endDate} if the selected filter ranges is {CUSTOM_RANGE}
     * selectedItem: The selected filter ranges.
     * isOpenRangePicker: True if the selected filter ranges is {CUSTOM_RANGE}
     */
  }, {
    key: "onMount",
    value: function onMount() {
      var _this$props = this.props,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate,
        rangesName = _this$props.rangesName,
        locale = _this$props.locale;
      var selectedRange = [startDate, endDate];
      var ranges = this.getFilterRanges();
      _moment.default.locale(locale);

      // Find selected item
      var selectedItem = _lodash.default.findKey(ranges, function (range) {
        if (range) {
          return _dateUtil.default.isRangeSame(selectedRange, range);
        }
        return rangesName.CUSTOM_RANGE;
      });
      var isCustomRangeSelected = selectedItem === rangesName.CUSTOM_RANGE;
      this.setState({
        selectedItem: selectedItem,
        isOpenRangePicker: isCustomRangeSelected,
        rangePickerStartDate: isCustomRangeSelected ? startDate : null,
        rangePickerEndDate: isCustomRangeSelected ? endDate : null
      });
    }
  }, {
    key: "onSelectRange",
    value: function onSelectRange(_x, _x2) {
      return (_onSelectRange = _onSelectRange || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(nameRangePicker, dateRange) {
        var _this$state, isOpenDropDown, selectedItem, _this$props2, rangesName, startDate, endDate;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$state = this.state, isOpenDropDown = _this$state.isOpenDropDown, selectedItem = _this$state.selectedItem;
              _this$props2 = this.props, rangesName = _this$props2.rangesName, startDate = _this$props2.startDate, endDate = _this$props2.endDate; // Prevent double click on custom range filter
              if (!(nameRangePicker === rangesName.CUSTOM_RANGE && selectedItem === rangesName.CUSTOM_RANGE)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              if (!dateRange) {
                _context.next = 11;
                break;
              }
              _context.next = 7;
              return this.onChange(dateRange.startDate, dateRange.endDate, nameRangePicker);
            case 7:
              this.batchStateUpdates({
                prevSelectedItem: selectedItem,
                selectedItem: nameRangePicker,
                isOpenRangePicker: false,
                isOpenDropDown: false,
                rangePickerStartDate: null,
                rangePickerEndDate: null
              });
              this.setState({
                isOpenDropDown: false
              });
              _context.next = 12;
              break;
            case 11:
              this.setState({
                prevSelectedItem: selectedItem,
                selectedItem: nameRangePicker,
                isOpenRangePicker: true,
                isOpenDropDown: isOpenDropDown,
                rangePickerStartDate: startDate,
                rangePickerEndDate: endDate
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }))).apply(this, arguments);
    }
  }, {
    key: "onDateRangesChange",
    value: function onDateRangesChange(dates) {
      this.setState({
        rangePickerStartDate: dates.startDate,
        rangePickerEndDate: dates.endDate
      });
    }
  }, {
    key: "onApply",
    value: function onApply() {
      var _this$state2 = this.state,
        rangePickerStartDate = _this$state2.rangePickerStartDate,
        rangePickerEndDate = _this$state2.rangePickerEndDate,
        selectedItem = _this$state2.selectedItem;
      this.setState({
        isOpenDropDown: false,
        prevSelectedItem: selectedItem
      });
      this.onChange(rangePickerStartDate, rangePickerEndDate, selectedItem);
    }
  }, {
    key: "onCancel",
    value: function onCancel() {
      var _this$props3 = this.props,
        startDate = _this$props3.startDate,
        endDate = _this$props3.endDate,
        rangesName = _this$props3.rangesName;
      var prevSelectedItem = this.state.prevSelectedItem;
      var _this$state3 = this.state,
        selectedItem = _this$state3.selectedItem,
        isOpenRangePicker = _this$state3.isOpenRangePicker;
      if (prevSelectedItem && prevSelectedItem !== rangesName.CUSTOM_RANGE) {
        selectedItem = prevSelectedItem;
        isOpenRangePicker = false;
      }
      this.batchStateUpdates({
        rangePickerStartDate: startDate,
        rangePickerEndDate: endDate,
        isOpenDropDown: false,
        selectedItem: selectedItem,
        isOpenRangePicker: isOpenRangePicker
      });
      this.setState({
        isOpenDropDown: false,
        anchor: null
      });
    }
  }, {
    key: "onChange",
    value: function onChange(startDate, endDate, selectedItem) {
      if (startDate && endDate) {
        this.props.onChange({
          startDate: (0, _moment.default)(startDate.startOf('day')),
          endDate: (0, _moment.default)(endDate.endOf('day'))
        }, selectedItem);
      }
      return this.props.onChange({
        startDate: startDate,
        endDate: endDate
      }, selectedItem);
    }
  }, {
    key: "getFilterRanges",
    value: function getFilterRanges() {
      var newRanges = _objectSpread({}, this.props.ranges);
      newRanges[this.props.rangesName.CUSTOM_RANGE] = null;
      return newRanges;
    }

    /**
     * Sets the state of the component with the provided updates after a delay of 500 milliseconds.
     *
     * @param {object} updates - An object containing the updated state values.
     */
  }, {
    key: "batchStateUpdates",
    value: function batchStateUpdates(updates) {
      var _this2 = this;
      setTimeout(function () {
        _this2.setState(updates);
      }, 500);
    }
  }, {
    key: "isCustomRangeSelected",
    value: function isCustomRangeSelected() {
      return this.state.selectedItem === this.props.rangesName.CUSTOM_RANGE;
    }
  }, {
    key: "isOutsideRange",
    value: function isOutsideRange(renderDate) {
      var blocked = true;
      var _this$state4 = this.state,
        rangePickerStartDate = _this$state4.rangePickerStartDate,
        rangePickerEndDate = _this$state4.rangePickerEndDate;
      var _this$props4 = this.props,
        dateLimit = _this$props4.dateLimit,
        maxDate = _this$props4.maxDate,
        minDate = _this$props4.minDate;
      var now = (0, _moment.default)();
      if (dateLimit) {
        var rangeLimit = dateLimit.days;
        if (renderDate && (renderDate.isBefore(minDate, 'days') || renderDate.isAfter(maxDate, 'days'))) {
          // If the {renderDate} is not between minDate and startDate, should block.
          return blocked;
        }
        /*
         * While user is selecting {endDate}, should re-calculate the {maxDate}
         * We only care about this if the selected start date is in the past.
         */
        if (!rangePickerEndDate && rangePickerStartDate && rangePickerStartDate.isBefore(now, 'days')) {
          var newMaxDate = (0, _moment.default)(rangePickerStartDate).add(rangeLimit, 'days');
          if (renderDate.isAfter(newMaxDate, 'days')) {
            return blocked;
          }
        }
      }
      return !blocked;
    }
  }, {
    key: "openDropdown",
    value: function openDropdown(e) {
      var _this$state5 = this.state,
        selectedItem = _this$state5.selectedItem,
        isOpenRangePicker = _this$state5.isOpenRangePicker,
        rangePickerStartDate = _this$state5.rangePickerStartDate,
        rangePickerEndDate = _this$state5.rangePickerEndDate;
      e.preventDefault();
      this.setState({
        anchor: e.currentTarget
      });
      if (!this.props.endDate) {
        selectedItem = this.props.rangesName.CUSTOM_RANGE;
        isOpenRangePicker = true;
        rangePickerStartDate = null;
        rangePickerEndDate = null;
      }
      this.setState({
        isOpenDropDown: true,
        selectedItem: selectedItem,
        isOpenRangePicker: isOpenRangePicker,
        rangePickerStartDate: rangePickerStartDate,
        rangePickerEndDate: rangePickerEndDate
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(d) {
      return d ? _dateUtil.default.format(d, this.props.dateFormat) : this.props.dateFormat;
    }
  }, {
    key: "renderToggleControl",
    value: function renderToggleControl() {
      var _this3 = this;
      var _this$props5 = this.props,
        startDate = _this$props5.startDate,
        endDate = _this$props5.endDate,
        t = _this$props5.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "date-range-picker-btn-content-holder"
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          padding: endDate ? '4px 0px 4px 0' : '3px 12px',
          fontWeight: 'normal'
        }
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Glyphicon, {
        glyph: "calendar",
        className: "p-r-sm calender-icon"
      }), !startDate ? 'MM/DD/YYYY' : this.formatDate(startDate), /*#__PURE__*/_react.default.createElement("b", {
        className: "p-r-sm p-l-sm",
        style: {
          padding: '0 3px'
        }
      }, t('TO')), !endDate ? 'MM/DD/YYYY' : this.formatDate(endDate)), startDate && endDate && /*#__PURE__*/_react.default.createElement("span", {
        className: "clearDateX",
        "data-testid": "test-clear-date-x",
        onClick: function onClick() {
          _this3.setState({
            isOpenDropDown: false,
            rangePickerStartDate: null,
            rangePickerEndDate: null
          });
          _this3.onChange(null, null);
        },
        role: "button",
        tabIndex: 0,
        onKeyPress: function onKeyPress() {
          _this3.setState({
            isOpenDropDown: false,
            rangePickerStartDate: null,
            rangePickerEndDate: null
          });
          _this3.onChange(null, null);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fa fa-times"
      })));
    }
  }, {
    key: "renderRangePicker",
    value: function renderRangePicker() {
      if (this.state.isOpenRangePicker) {
        return /*#__PURE__*/_react.default.createElement(_rangePicker.default, {
          onChange: this.onDateRangesChange,
          startDate: this.state.rangePickerStartDate,
          endDate: this.state.rangePickerEndDate,
          isOutsideRange: this.isOutsideRange,
          className: "range-picker-container",
          dateFormat: this.props.dateFormat,
          monthFormat: this.props.monthFormat,
          initialVisibleMonth: this.props.initialVisibleMonth,
          actionBtn: this.renderActionControl(),
          t: this.props.t,
          locale: this.props.locale
        });
      }
      return null;
    }
  }, {
    key: "renderActionControl",
    value: function renderActionControl() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonToolbar, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, null, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        muiButtonProps: {
          className: 'cancel-btn',
          onClick: this.onCancel,
          disabled: !this.isCustomRangeSelected(),
          variant: 'text',
          color: 'text',
          id: 'date-range-cancel-btn',
          sx: {
            minWidth: 0
          }
        }
      }, t('Cancel'))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, null, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        muiButtonProps: {
          className: 'apply-btn',
          id: 'date-range-apply-btn',
          onClick: this.onApply,
          variant: 'text',
          sx: {
            minWidth: 0
          },
          disabled: !this.isCustomRangeSelected() || !this.state.rangePickerEndDate
        }
      }, t('Apply'))));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      // calc which side menu will show up, right/left, so no page overflow
      if (this.dateElementRef.current) {
        var dateElemCurr = this.dateElementRef.current;
        var xPosLeft = dateElemCurr.offsetLeft - dateElemCurr.scrollLeft + dateElemCurr.clientLeft;
        var windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        var xPosRight = dateElemCurr.getBoundingClientRect().right;
        var elem = document.getElementsByClassName('dropdown-menu')[0];
        if (elem) {
          var rightSpace = windowWidth - xPosLeft; // space to right of datepicker
          var leftSpace = xPosRight; // space to left of datepicker
          // whichever side has more space to display the menu, use that side.
          if (rightSpace < leftSpace) {
            elem.style.right = 0; // menu displays left side
          } else {
            elem.style.right = 'unset';
          }
        }
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "daterangepicker-content"
      }, /*#__PURE__*/_react.default.createElement(_menu.default, {
        onSelectRange: this.onSelectRange,
        selectedItem: this.state.selectedItem,
        ranges: this.getFilterRanges(),
        t: this.props.t
      }), this.renderRangePicker());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        startDate = _this$props6.startDate,
        endDate = _this$props6.endDate,
        t = _this$props6.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(this.props.className, " ").concat(CLASS_NAME),
        ref: this.dateElementRef
      }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        buttonType: "dropdown",
        label: this.renderToggleControl(),
        muiButtonProps: {
          title: "".concat(!startDate ? 'MM/DD/YYYY' : this.formatDate(startDate), " ").concat(t('TO'), " ").concat(!endDate ? 'MM/DD/YYYY' : this.formatDate(endDate)),
          variant: 'input',
          color: 'text',
          disabled: this.props.disabled,
          className: 'date-range-menu',
          endIcon: null,
          'aria-controls': this.state.isOpenDropDown ? 'button-dropdown' : undefined,
          'aria-haspopup': 'true',
          'aria-expanded': this.state.isOpenDropDown ? 'true' : undefined,
          disableElevation: true,
          onClick: this.openDropdown,
          sx: {
            width: 1,
            justifyContent: 'flex-start'
          }
        },
        muiMenuProps: {
          open: this.state.isOpenDropDown,
          anchorEl: this.state.anchor,
          onClose: this.onCancel,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
          },
          sx: {
            '.MuiList-root': {
              p: '32px 0 32px 24px',
              minWidth: 200,
              maxHeight: 406
            }
          }
        },
        menuItems: [/*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          disableRipple: true,
          disableGutters: true,
          focusVisibleClassName: "time-picker-dropdown-focused",
          sx: {
            '&:hover': {
              background: 'none'
            },
            cursor: 'default'
          },
          className: "date-range-menu-items"
        }, this.renderContent())]
      }));
    }
  }]);
  return DateRangePicker;
}(_react.Component);
DateRangePicker.propTypes = {
  className: _propTypes.default.string,
  dateFormat: _propTypes.default.string,
  monthFormat: _propTypes.default.string,
  startDate: _propTypes.default.instanceOf(_moment.default),
  endDate: _propTypes.default.instanceOf(_moment.default),
  maxDate: _propTypes.default.instanceOf(_moment.default),
  minDate: _propTypes.default.instanceOf(_moment.default),
  initialVisibleMonth: _propTypes.default.instanceOf(_moment.default),
  ranges: _propTypes.default.instanceOf(Object),
  rangesName: _propTypes.default.shape({
    CUSTOM_RANGE: _propTypes.default.string
  }),
  dateLimit: _propTypes.default.shape({
    days: _propTypes.default.number
  }),
  onChange: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool,
  t: _propTypes.default.func,
  locale: _propTypes.default.string
};
DateRangePicker.defaultProps = {
  className: '',
  startDate: null,
  endDate: null,
  maxDate: _constants.default.ConfigDateRangeMenuPicker.maxDate,
  minDate: _constants.default.ConfigDateRangeMenuPicker.minDate,
  dateFormat: _constants.default.DateTimeFormat.shortDate,
  dateLimit: _constants.default.ConfigDateRangeMenuPicker.rangeLimit,
  initialVisibleMonth: _constants.default.ConfigDateRangeMenuPicker.initialVisibleMonth,
  ranges: _constants.default.ConfigDateRangeMenuPicker.filterRanges,
  rangesName: _constants.default.FILTER_RANGES_NAME,
  monthFormat: _constants.default.DateTimeFormat.shortMonth,
  disabled: false,
  t: function t(x) {
    return x;
  },
  locale: 'en-us'
};
var _default = DateRangePicker;
exports.default = _default;